import React from "react";
//#region redux
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "store";
import { toggleLanguage } from "store/actions/commonActions";
//#endregion
//#region types
import { LocaleEnums } from "models/enums";
//#endregion
//#region components
import { Chip, Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const LanguageToggle: React.FC = (props) => {
  const dispatch = useDispatch();

  const currentLanguage = useSelector((state: AppState) => state.common.locale.language);

  const changeLanguage = () => {
    dispatch(toggleLanguage());
  };

  return (
    <Grid className={cssExports.layoutChips}>
      <Chip
        color="default"
        label={currentLanguage === LocaleEnums.LocaleType.en ? "sv" : "en"}
        clickable={true}
        onClick={changeLanguage}
        className={cssExports.languageChip}
      />
    </Grid>
  );
};

export default LanguageToggle;
